<template>
	<!-- 银行流水新手指引 -->
	<el-dialog
      title="更新提示"
      id='noviceGuide'
      :visible.sync="isShow"
      width="1100px"
      class='default-dialog'
      :close-on-click-modal='false'
      :close-on-press-escape="false"
      >
        <div class='noviceGuide_wrapper'>
        	<div class='noviceGuide_wrapper-content'>
        		<p>1、在新增/编辑科目页面新增功能；</p>
        		<p>2、在凭证中新增分配功能；</p>
        		<p>3、报表界面中新增统计方法切换；</p>
        		<p>4、新增流量汇总表。</p>
        	</div>
        	<div class='video_wrapper'>
        		<video-player  class="video-player vjs-custom-skin"
		            ref="videoPlayer"
		            :playsinline="true"
		            :options="playerOptions"
		        ></video-player>
        	</div>
        	
        </div>
          
    </el-dialog>
</template>
<script>
	export default {
		props:{
			isNoviceGuideDialogShow:Boolean,
		},
		components:{
			
		},
		data() {
			return {
				playerOptions : {
			        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
			        autoplay: false, //如果true,浏览器准备好时开始回放。
			        muted: false, // 默认情况下将会消除任何音频。
			        loop: false, // 导致视频一结束就重新开始。
			        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
			        language: 'zh-CN',
			        aspectRatio: '16:7', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
			        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
			        sources: [{
			          type: "",
			          src: '/static/video/noviceGuide.mov'//url地址          
			          // src: "" //url地址
			        }],
			        poster: "", //你的封面地址
			        // width: document.documentElement.clientWidth,
			        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
			        controlBar: {
			          timeDivider: true,
			          durationDisplay: true,
			          remainingTimeDisplay: false,
			          fullscreenToggle: true  //全屏按钮
			        }
			    },
			}
		},
		created() {
			
		},
		computed:{
			
			// 显示弹窗
			isShow: {
				get () {
					return this.isNoviceGuideDialogShow;
				},
				set (val) {
					this.$emit('update:isNoviceGuideDialogShow', val);
				}
			},
		},
		methods:{

		}
			
	}
</script>
<style lang='less'>
	#noviceGuide {
		.el-dialog__body {
			padding: 0
		}
		.noviceGuide_wrapper {
			&-content {
				padding: 20px;
				line-height: 26px;
				color: #333;
			}
			.video-js {
				background: #fff;
			}
		}
	}
		
	
</style>


// WEBPACK FOOTER //
// src/components/dialog/noviceGuide.vue